<template>
  <div v-cloak class="animated fadeIn">
    <h1 class="mb-4">Violation Tracker</h1>
    <div class="card">
      <div class="card-header bg-transparent">
        <div class="d-flex justify-content-between align-items-center">
          <span>Violations</span>
          <file-dragdrop
            title="Select a document file to upload"
            label="Upload"
            @upload="
              (files) =>
                $uploadFile({
                  fileId: 5,
                  file: files[0],
                  onProgress: (progress) => onProgress(progress),
                })
            "
            v-if="!progressValue"
          >
          </file-dragdrop>
          <CProgress
            v-else
            :value="progressValue"
            animated
            showPercentage
            class="w-50"
          />
        </div>
        <hr />
      </div>
      <div class="card-body">
        <table-component
          :columns="[...columns, 'actions']"
          :data="docs"
          :headings="headings"
        >
          <template slot="nb_of_lines" slot-scope="{ row }">
            <span class="float-right">{{ row.nb_of_lines }}</span>
          </template>
          <template slot="filename" slot-scope="{ row }">
            <span
              class="link pointer"
              @click="
                $downloadFile({
                  name: row.filename,
                  fileId: 5,
                  url: `${BASE_URL}api/files/download/`,
                })
              "
            >
              {{ row.filename }}
            </span>
          </template>
          <template slot="actions" slot-scope="{ row }">
            <a
              @click="() => deleteFile(row.filename, 5)"
              class="btn btn-outline-danger"
            >
              <i class="fa fa-trash-o"></i>
            </a>
          </template>
        </table-component>
      </div>
    </div>
    <div class="card">
      <div class="card-header bg-transparent">
        Output File
        <hr />
      </div>
      <div class="card-body">
        <table-component
          :columns="columns"
          :data="outputs"
          :headings="headings"
        >
          <template slot="nb_of_lines" slot-scope="{ row }">
            <span class="float-right">{{ row.nb_of_lines }}</span>
          </template>
          <template slot="filename" slot-scope="{ row }">
            <span
              class="link pointer"
              @click="
                $downloadFile({
                  name: row.filename,
                  fileId: 6,
                  url: `${BASE_URL}api/files/download/`,
                })
              "
            >
              {{ row.filename }}
            </span>
          </template>
        </table-component>
      </div>
    </div>
    <div class="row" v-for="fileName in ['black_list', 'white_list']">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-transparent text-capitalize">
            {{ fileName.replaceAll("_", " ") }}
            <hr />
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <button
                @click="
                  $downloadFile({
                    name: `${fileName}.xlsx`,
                    fileId: 8,
                    url: `${BASE_URL}api/files/download/`,
                  })
                "
                class="btn btn-outline-primary"
              >
                <i class="fa fa-download pr-1"></i>
                Download {{ fileName.replaceAll("_", " ") }} file
              </button>
              <file-dragdrop
                title="Select a document file to upload"
                label="Upload"
                @upload="
                  (files) =>
                    $uploadFile({
                      fileId: 8,
                      file: files[0],
                      onProgress: (progress) => onProgress(progress),
                      fileName: `${fileName}.xlsx`,
                    })
                "
              >
              </file-dragdrop>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "ViolationTracker",
  data() {
    return {
      BASE_URL,
      columns: ['filename', 'modified', 'nb_of_lines'],
      headings: {'nb_of_lines': 'Nb of violations'},
      inputFile: "",
      progressValue: null,
      docs: [],
      outputs: [],
    };
  },
  mounted(){
    this.getDocs()
  },
  methods: {
    async getDocs() {
      const { data } = await this.$request({
        url: `${BASE_URL}api/overview/violations`,
      });
      this.docs = data.docs;
      this.outputs = data.outputs;
    },

    onProgress(progress) {
      if (progress === 100) {
        this.getDocs();
        return (this.progress = null);
      }
      this.progress = progress;
    },
    async deleteFile(filename, fileId) {
      if (
        !(await confirm(
          `Are you sure you want to delete ${filename || "this resource"}?`
        ))
      )
        return;
      await this.$request({
        url: `${this.BASE_URL}api/files/delete/`,
        query: { file_id: fileId, name: filename },
        method: "DELETE",
      });
      this.getDocs();
    },
  },
};
</script>

<style scoped></style>
